/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SSRV2RuleDelete
 */
export interface SSRV2RuleDelete {
    /**
     * 
     * @type {string}
     * @memberof SSRV2RuleDelete
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SSRV2RuleDelete
     */
    deleted?: boolean;
}

export function SSRV2RuleDeleteFromJSON(json: any): SSRV2RuleDelete {
    return SSRV2RuleDeleteFromJSONTyped(json, false);
}

export function SSRV2RuleDeleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): SSRV2RuleDelete {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
    };
}

export function SSRV2RuleDeleteToJSON(value?: SSRV2RuleDelete | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'deleted': value.deleted,
    };
}


